module.exports = __webpack_public_path__ + "img/ic_qrcode_tw.85df51e.webp";